import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import VueClipboard from 'vue-clipboard2'
import toast from './utils/plugins/toast.js'
import $ from 'jquery'
import axios from './utils/api/axios.js'
import session from './utils/session.js'
import store from './utils/store/index.js'
import cache from './utils/cache/index.js'
import analytics from './utils/analytics.js'
import analyticsExposure from './utils/analyticsExposure.js'
import LoadingPlugin from './utils/plugins/loading.js'
import '@/assets/css/index_pc.css'
import '@/assets/css/index_m.css'

window.$ = window.jQuery = $;
Vue.prototype.$axios = axios;
Vue.prototype.$cache = cache;
Vue.prototype.$session = session;
Vue.prototype.$analytics = analytics;
Vue.directive('analytics-exposure', analyticsExposure);
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueClipboard)
Vue.use(LoadingPlugin);
Vue.use(toast);

router.afterEach((to, from) => {
	if (typeof window !== 'undefined' && window.gtag) {
		window.gtag('event', 'page_view', {
			'send_to': 'AW-16623374979',
			'screen_name': to.fullPath
		});
	}
});

analytics.init({
	userId: session.getUserId(),
	context: {
		game_code: cache.getGameCode() || null
	}
});

store.dispatch('initGameData').then((game) => {
	const link = document.createElement('link');
	link.rel = 'stylesheet';
	link.href = require('@/assets/theme/style.css');

	// 动态设置CSS变量
	document.documentElement.style.setProperty('--theme-color', game.theme);

	import('./utils/i18n/index.js').then((module) => {
		const i18nInstance = module.default;
		new Vue({
			router,
			store,
			i18n: i18nInstance,
			render: h => h(App),
		}).$mount('#app');
	});

});
